<div class="evento-form-error my-2">
  <i class="fa fa-info-circle"></i>
  {{ message }}
</div>
